<template>
    <div class="modal" :class="{ 'open_modal': openModal}">
        <div class="modal_overlay"></div>
        <div class="modal_inner max_height_80">
            <div class="modal_header">
                <span class="close_icon close_icon_sm" @click="closeModal()">×</span>
                <h2>{{ $t('sidebar.lectureCommon.exam_list') }}</h2>
            </div>
            <div class="modal_wrapper">
                <div class="modal_content modal_1400p">
                    <div class="container">
                        <div class="row mt_10">
                            <div class="col_2">
                                <div class="form-group ">
                                    <div class="d_flex_start">
                                        <div class="dropdown custom_dropdown mr_10">
                                            <button class="btn">
                                                <span> {{ filter.subject != '' && subjects.length ? subjects.find(s=> s.id == parseInt(filter.subject)).name : $t('common.subject') }}</span>
                                            </button>
                                            <div class="dropdown_menu">
                                                <ul>
                                                    <li @click="subjectFilter(subject.id)" v-for="subject in subjects" :key="'subject'+subject.id"><a role="button">{{ subject.name }}</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col_1">
                                <div class="form-group ">
                                    <div class="d_flex_start">
                                        <div class="dropdown custom_dropdown mr_10">
                                            <button class="btn">
                                                <span> {{ filter.grade != '' && grades.length ? grades.find(s=> s.id == parseInt(filter.grade)).name : $t('common.grade') }}</span>
                                            </button>
                                            <div class="dropdown_menu">
                                                <ul>
                                                    <li @click="gradeFilter(grade.id)" v-for="grade in grades" :key="'grade'+grade.id"><a role="button">{{ grade.name }}</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col_1">
                                <div class="form-group ">
                                    <div class="d_flex_start">
                                        <div class="dropdown custom_dropdown mr_10">
                                            <button class="btn">
                                                <span> {{ filter.semester != '' && semesters.length ? semesters.find(s=> s.id == parseInt(filter.semester)).name : $t('common.semester') }}</span>
                                            </button>
                                            <div class="dropdown_menu">
                                                <ul>
                                                    <li @click="semesterFilter(semester.id)" v-for="semester in semesters" :key="'semester'+semester.id"><a role="button">{{ semester.name }}</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col_2">
                                <div class="drop-down">
                                    <div class="selected">
                                        <span>{{ filter.unit != '' && units.length ? units.find(s=> s.id == parseInt(filter.unit)).unit_name : $t('common.unit') }}</span>
                                    </div>
                                    <div class="options">
                                        <ul style="display: none;">
                                            <li @click="unitFilter(unit.id)" v-for="unit in units" :key="'unit'+unit.id">{{ unit.unit_name }}<span class="value">{{ unit.id }}</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col_2">
                                <div class="form-group ">
                                    <div class="d_flex_start">
                                        <div class="dropdown custom_dropdown mr_10">
                                            <button class="btn">
                                                <span> {{ filter.assign != '' && assigns.length ? assigns.find(s=> s.id === parseInt(filter.assign)).assign_name : $t('common.assign') }}</span>
                                            </button>
                                            <div class="dropdown_menu">
                                                <ul>
                                                    <li @click="assignFilter(assign.id)" v-for="assign in assigns" :key="'assign'+assign.id"><a role="button">{{ assign.assign_name }}</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col_4">
                                <div class="form-group">
                                    <div class="d_flex_end">
                                        <div class="form_row_inline">
                                            <input type="text" class="form_global" :placeholder="$t('common.search')" v-model="queryParams.search">
                                        </div>
                                        <div class="form_row_inline ml_10">
                                            <div class="btn btn_common_type_2 mr_10 width_150p" @click="queryParams.page = 1 ; searchQuery()">{{ $t('common.search') }}</div>
                                            <div class="btn btn_secondary width_150p" @click="resetAll()">{{ $t('common.reset') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="table_responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th class="width_50p">
                                                <div class="form-group mb_0">
                                                    <label style="min-height: 0px"></label>
                                                    <div class="form_checkbox">
                                                        <input type="checkbox" id="all" name="all" value="" v-model="selectAll">
                                                        <label for="all"></label>
                                                    </div>
                                                </div>
                                            </th>
                                            <!-- <th>{{ $t('sidebar.exam_type.exam_type') }}</th> -->
                                            <th>{{ $t('common.title') }}</th>
                                            <th>{{ $t('sidebar.exams.exam_time') }}</th>
                                            <th>{{ $t('common.action') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="exams.length">
                                        <tr v-for="(exam, index) in exams" :key="index" :class="{active: ids.includes(exam.id)}">
                                            <td class="width_50p">
                                                <div class="form-group mb_0">
                                                    <label style="min-height: 0px"></label>
                                                    <div class="form_checkbox">
                                                        <input type="checkbox" :id="'new_id_'+exam.id" name="exams" :value="exam.id" v-model="ids">
                                                        <label :for="'new_id_'+exam.id"></label>
                                                    </div>
                                                </div>
                                            </td>
                                            <!-- <td>{{ exam.examType ? exam.examType.name  : '' }}</td> -->
                                            <td>{{ exam.title }}</td>
                                            <td>{{ exam.exam_time }} {{ $t('sidebar.lectureCommon.minute') }}</td>
                                            <td class="width_50p">
                                                <a role="button" class="color_success cursor_pointer" @click="selectThisExam(exam.id)">{{ ids.includes(exam.id) ? '' : $t('common.select') }}</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="8">{{ $t('sidebar.lectureCommon.no_product_message') }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col_12">
                                <pagination-component :pagination="pagination" @changePage="pageChanged"></pagination-component>
                            </div>
                        </div>
                        <div class="common_content">
                            <div class="common_content_btn d_flex_end">
                                <button class="btn btn_blue ml_5" @click="selectedExam()">{{ $t('sidebar.exams.add_exam') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PaginationComponent from "@/components/shared/PaginationComponent";
export default {
    name: "ExamModal",
    components: {
        PaginationComponent
    },
    props: {
        type: {
            type: String,
            required: true
        },
        openModal: {
            type: Boolean,
            required: true
        },
        unit_id: {
            type: [String, Number],
            required: false
        },
        subject_id: {
            type: [String, Number],
            required: false
        },
        grade_id: {
            type: [String, Number],
            required: false
        },
        semester_id: {
            type: [String, Number],
            required: false
        },
    },
    data() {
        return {
            filter: {
                subject: this.subject_id,
                grade: this.grade_id,
                semester: this.semester_id,
                unit: this.unit_id,
                assign: '',
            },
            queryParams: {
                page: 1,
                per_page: 10,
                search: '',
                search_columns: 'title'
            },
            assigns: [{
                    id: 1,
                    assign_name: this.$t('common.assigned'),
                },
                {
                    id: 2,
                    assign_name: this.$t('common.not_assigned'),
                }
            ],
            pagination: null,
            ids: [],
            exams: [],
            subjects: [],
            semesters: [],
            grades: [],
            units: [],
            selectAll: false
        }
    },
    watch: {
        openModal: {
            deep: true,
            handler(value) {
                if (value)
                    this.loadData();
            }
        },
        selectAll: function () {
            if (this.selectAll)
                this.ids = this.exams.map((i) => i.id)
            else
                this.ids = []
        }
    },
    created() {
        this.loadData();
        this.axios.get('/subjects').then((response) => this.subjects = response.data.data);
        this.axios.get('/grades').then((response) => this.grades = response.data.data);
        this.axios.get('/semesters').then((response) => this.semesters = response.data.data);
        this.axios.get('/units').then((response) => this.units = response.data.data);
    },
    methods: {
        loadData() {
            this.axios.get('/exams', {
                params: {
                    ...this.queryParams,
                    ...this.filter
                }
            }).then((response) => {
                this.exams = response.data.data;
                this.pagination = response.data.meta;
            })
        },
        selectedExam() {
            if (this.type == 'daily-learning') {
                if (this.ids.length > 1) {
                    this.showFailMsg(this.$t('sidebar.courseLearning.dailyLearningExamLimitMsg'))
                } else {
                    let dailyLearningData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('dailyLearningData', dailyLearningData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }

            if (this.type == 'daily-test') {
                if (this.ids.length > 1) {
                    this.showFailMsg(this.$t('sidebar.courseLearning.dailyLearningExamLimitMsg'))
                } else {
                    let dailyExamData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('dailyExamData', dailyExamData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }

            if (this.type == 'final-test') {
                if (this.ids.length > 1) {
                    this.showFailMsg(this.$t('sidebar.courseLearning.dailyLearningExamLimitMsg'))
                } else {
                    let finalExamData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('finalExamData', finalExamData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }

            if (this.type == 'top-solution') {
                if (this.ids.length > 1) {
                    this.showFailMsg('You can add Maximum 1 Exam')
                } else {
                    let topSolutionData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('topSolutionData', topSolutionData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }

            if (this.type == 'thinking-ability') {
                if (this.ids.length > 1) {
                    this.showFailMsg('You can add Maximum 1 Exam')
                } else {
                    let thinkingAbilityData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('thinkingAbilityData', thinkingAbilityData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }
            if (this.type == 'examination') {
                if (this.ids.length > 1) {
                    this.showFailMsg('You can add Maximum 1 Exam')
                } else {
                    let examinationData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('examinationData', examinationData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }
            if (this.type == 'systematic_mathematics') {
                if (this.ids.length > 3) {
                    this.showFailMsg('You can add Maximum 3 Exam')
                } else {
                    let systematicExamData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('systematicExamData', systematicExamData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }
            if (this.type == 'parochial_mathematics') {
                if (this.ids.length > 3) {
                    this.showFailMsg('You can add Maximum 3 Exam')
                } else {
                    let parochialExamData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('parochialExamData', parochialExamData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }
            if (this.type == 'convergence_mathematics') {
                if (this.ids.length > 3) {
                    this.showFailMsg('You can add Maximum 3 Exam')
                } else {
                    let convergenceExamData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('convergenceExamData', convergenceExamData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }
            if (this.type == 'parent_special_lecture') {
                if (this.ids.length > 3) {
                    this.showFailMsg('You can add Maximum 3 Exam')
                } else {
                    let parentLectureExamData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('parentLectureExamData', parentLectureExamData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }
            if (this.type == 'enjoy_learning') {
                if (this.ids.length > 3) {
                    this.showFailMsg('You can add Maximum 3 Exam')
                } else {
                    let enjoyLearningExamData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('enjoyLearningExamData', enjoyLearningExamData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }
            if (this.type == 'special_exams') {
                if (this.ids.length > 4) {
                    this.showFailMsg('You can add Maximum 4 Exam')
                } else {
                    let specialLectureExamData = this.exams.filter((exam) => this.ids.includes(exam.id))
                    this.$emit('specialLectureExamData', specialLectureExamData)
                    this.ids = []
                    this.selectAll = false
                    this.closeModal();
                }
            }
        },
        selectThisExam(id) {
            if (this.ids.includes(id)) {
                var index = this.ids.indexOf(id);
                if (index !== -1) {
                    this.ids.splice(index, 1);
                }
            } else {
                this.ids.push(id)
            }
        },
        resetAll() {
            this.filter = {
                subject: '',
                grade: '',
                semester: '',
                unit: '',
                assign: '',
            }
            this.queryParams = {
                page: 1,
                per_page: 10,
                search: '',
                search_columns: 'title'
            }

            this.loadData()
        },
        subjectFilter(id) {
            this.filter.subject = id
            this.loadData()
        },
        gradeFilter(id) {
            this.filter.grade = id
            this.loadData()
        },
        semesterFilter(id) {
            this.filter.semester = id
            this.loadData()
        },
        unitFilter(id) {
            this.filter.unit = id
            this.loadData()
        },
        assignFilter(id) {
            this.filter.assign = id
            this.loadData()
        },
        searchQuery() {
            this.loadData()
        },
        pageChanged(page) {
            this.queryParams.page = page;
            this.loadData()
        },
        closeModal() {
            this.$emit('closeModal', false)
        }
    }
}
</script>

<!-- <style scoped>
.modal_header h2 {
    text-align: center;
    padding: 20px 0px;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style> -->
